import type { ThemeKey } from "@/lib/theme-review";
import imgPlanet from "@/assets/tr-home/preview-theme-planet.jpg.asset.json";
import imgTech from "@/assets/tr-home/preview-theme-tech.jpg.asset.json";
import imgEconomy from "@/assets/tr-home/preview-theme-economy.jpg.asset.json";
import imgMeaning from "@/assets/tr-home/preview-theme-meaning.jpg.asset.json";
import coverAi from "@/assets/book-cover.webp";
import coverClimate from "@/assets/book-cover-2.webp";
import coverLoneliness from "@/assets/book-cover-3.webp";
import coverSpace from "@/assets/book-cover-space.jpg";

/** Shared visual vocabulary for the four fixed themes (same tokens as the homepage). */
export const THEME_DOT: Record<ThemeKey, string> = {
  planet: "bg-theme-planet",
  tech: "bg-theme-tech",
  economy: "bg-theme-economy",
  meaning: "bg-theme-meaning",
};
export const THEME_TEXT: Record<ThemeKey, string> = {
  planet: "text-theme-planet",
  tech: "text-theme-tech",
  economy: "text-theme-economy",
  meaning: "text-theme-meaning",
};
export const THEME_FILL: Record<ThemeKey, string> = {
  planet: "fill-theme-planet",
  tech: "fill-theme-tech",
  economy: "fill-theme-economy",
  meaning: "fill-theme-meaning",
};
/** PREVIEW ONLY: same placeholder theme photos as the homepage until licensed photos arrive. */
export const THEME_IMG: Record<ThemeKey, string> = {
  planet: imgPlanet.url,
  tech: imgTech.url,
  economy: imgEconomy.url,
  meaning: imgMeaning.url,
};

export type SiteBook = { title: string; year: string; cover: string; to: string; summary: string };

/** Real books (titles, covers, summaries from the books page). */
export const BOOKS: Record<"ai" | "climate" | "loneliness" | "space", SiteBook> = {
  ai: {
    title: "Yapay Zekâ: Gücün İki Yüzü",
    year: "2024",
    cover: coverAi,
    to: "/kitaplar/yapay-zeka-gucun-iki-yuzu",
    summary:
      "Yapay zekânın yükselişini umut ve risk ekseninde okuyan bir saha rehberi. Teknolojinin gündelik hayata, iş dünyasına ve topluma etkilerini sade bir dille ele alıyor.",
  },
  climate: {
    title: "İklim Değil, İnsanlık Krizi",
    year: "2023",
    cover: coverClimate,
    to: "/kitaplar/iklim-degil-insanlik-krizi",
    summary:
      "Sürdürülebilirliği insan, gezegen, ekonomi ve teknoloji boyutlarıyla okuyan bir çağrı. İklim krizinin aslında bir insanlık meselesi olduğunu anlatıyor.",
  },
  loneliness: {
    title: "Yalnızlık A.Ş.",
    year: "2026",
    cover: coverLoneliness,
    to: "/kitaplar/yalnizlik-as",
    summary: "Yalnızlık nasıl en kârlı sektör haline geldi? Kitabın tam PDF'ini üye olarak ücretsiz indirebilirsiniz.",
  },
  space: {
    title: "Hayatı Yaşanır Kılan, Boşluktur",
    year: "2026",
    cover: coverSpace,
    to: "/kitaplar/hayati-yasanir-kilan-bosluktur",
    summary:
      "Her şeyi verimlilik hesabına bağlayan çağda ölçünün dışında kalması gerekenleri; güveni, muhakemeyi, anlamı ve birlikte geçirilen zamanı savunan kitap.",
  },
};

/**
 * "İlgili Kitap" per theme — editorial default pending the author's confirmation.
 * Change here only; pages read it from this single map.
 */
export const THEME_BOOK: Record<ThemeKey, SiteBook> = {
  planet: BOOKS.climate,
  tech: BOOKS.ai,
  economy: BOOKS.loneliness,
  meaning: BOOKS.space,
};
